import { render } from "./new-instruction-time.vue?vue&type=template&id=119a0c24&scoped=true"
import script from "./new-instruction-time.vue?vue&type=script&lang=js"
export * from "./new-instruction-time.vue?vue&type=script&lang=js"

import "./new-instruction-time.vue?vue&type=style&index=0&id=119a0c24&lang=scss&scoped=true"

import exportComponent from "/Users/mac/richlesse/41devs/teamsecu/teamsecu-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-119a0c24"]])

export default __exports__